import { useState } from 'react';
import { useData, submitForm } from '../../hooks/useData';
import { Spinner, Modal, PageHeader, Field, Empty, EditBtn, DeleteBtn } from './index';
import toast from 'react-hot-toast';

export function makeLookupPage({ title, fetchFn, createFn, updateFn, deleteFn, fieldKey, fieldLabel }) {
  return function LookupPage() {
    const { data, loading, reload } = useData(fetchFn);
    const [modal, setModal] = useState(null);
    const [val, setVal]     = useState('');
    const [active, setActive] = useState(1);

    const openAdd  = ()    => { setVal(''); setActive(1); setModal({ mode: 'add' }); };
    const openEdit = (row) => { setVal(row[fieldKey]); setActive(row.active_yes_no); setModal({ mode: 'edit', row }); };
    const close    = ()    => setModal(null);

    const handleSave = async () => {
      const payload = { [fieldKey]: val, active_yes_no: active };
      if (modal.mode === 'add') await submitForm(() => createFn(payload), `${title} added`, reload, close);
      else await submitForm(() => updateFn(modal.row.id, payload), `${title} updated`, reload, close);
    };

    const handleDelete = async (id) => {
      if (!window.confirm('Delete this record?')) return;
      try { await deleteFn(id); toast.success('Deleted'); reload(); }
      catch (e) { toast.error(e.response?.data?.message || 'Error'); }
    };

    return (
      <div>
        <PageHeader title={`Manage ${title}`}
          action={<button className="btn btn-primary btn-sm" onClick={openAdd}>+ Add {title}</button>} />
        <div className="card">
          {loading ? <Spinner /> : (
            <div className="table-wrap">
              {data.length === 0 ? <Empty msg={`No ${title.toLowerCase()} found`} /> : (
                <table>
                  <thead><tr><th>#</th><th>{fieldLabel}</th><th>Status</th><th>Actions</th></tr></thead>
                  <tbody>{data.map(row => (
                    <tr key={row.id}>
                      <td className="text-muted font-mono" style={{ width: 60 }}>{row.id}</td>
                      <td className="td-primary">{row[fieldKey]}</td>
                      <td>
                        <span className={`badge ${row.active_yes_no ? 'badge-active' : 'badge-inactive'}`}>
                          {row.active_yes_no ? 'Active' : 'Inactive'}
                        </span>
                      </td>
                      <td>
                        <div className="action-cell">
                          <EditBtn onClick={() => openEdit(row)} />
                          <DeleteBtn onClick={() => handleDelete(row.id)} />
                        </div>
                      </td>
                    </tr>
                  ))}</tbody>
                </table>
              )}
            </div>
          )}
        </div>

        {modal && (
          <Modal title={modal.mode === 'add' ? `Add ${title}` : `Edit ${title}`} onClose={close}
            footer={<>
              <button className="btn btn-secondary" onClick={close}>Cancel</button>
              <button className="btn btn-primary" onClick={handleSave}>Save</button>
            </>}>
            <Field label={fieldLabel} required>
              <input type="text" value={val} onChange={e => setVal(e.target.value)} autoFocus />
            </Field>
            <Field label="Status">
              <select value={active} onChange={e => setActive(Number(e.target.value))}>
                <option value={1}>Active</option>
                <option value={0}>Inactive</option>
              </select>
            </Field>
          </Modal>
        )}
      </div>
    );
  };
}
